"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataInputAssociation = void 0;
const BaseElement_1 = require("./BaseElement");
/**
 * Contains a BPMN DataInputAssociation.
 * These associations signify that a FlowNode requires data from a DataObject or DataStore.
 */
class DataInputAssociation extends BaseElement_1.BaseElement {
}
exports.DataInputAssociation = DataInputAssociation;
//# sourceMappingURL=DataInputAssociation.js.map